import React, { FC } from "react";
import PayPalSVG from "./paypal.svg";

type Props = JSX.IntrinsicAttributes;

export const PayPalIcon: FC<Props> = (props) => {
  return <PayPalSVG {...props} />;
};
